import React, { Fragment, useEffect, useState } from "react";
import "./styles/index.scss";
import { clickToLinkHandler } from "../../../helpers/utils";
import { connect } from "react-redux";
import { MenuList } from "./menuList";
import CloseLargeIcon from "../../common/icons/closeIcon/closeLargeIcon";
import colors from "../../../colors";
import { abbreviateNumber } from "../../../helpers/utilsTS";
import * as api from "../../../api/generated-api";
import { getDealById } from "../../../api/deals/deals";
import {
  configureAuthHeader,
  configureBaseUrl,
} from "../../../api/axiosConfig";
import { UserWithPersonWithOrganizationPersons } from "../../../api/types";

type DealsMenuProps = {
  orgId: number;
  dealId: number;
  isBeforeCreateLocation: boolean;
  pathname: string;
  user: UserWithPersonWithOrganizationPersons;
  token: string;
};
const SelectDealTypePage = (props: DealsMenuProps) => {
  const { token, dealId, orgId, pathname, isBeforeCreateLocation } = props;

  configureBaseUrl();
  configureAuthHeader(token);

  const [deal, setDeal] = useState<api.Deal>();
  const [createNewDealMenuVisibility, setCreateNewDealsMenuVisibility] =
    useState(false);

  useEffect(() => {
    //Note: Somewhere we are linking to this page with "create" in the deal id position
    if (dealId && orgId && dealId.toString() != "create") {
      getDealById(orgId, dealId, (fetchedDeal) => {
        setDeal(fetchedDeal);
      });
    }
  }, [dealId, orgId]);

  useEffect(() => {
    if (isBeforeCreateLocation) {
      setCreateNewDealsMenuVisibility(true);
    }
  }, [isBeforeCreateLocation]);

  if (!pathname) {
    return null;
  }

  return (
    <div
      className={`deals-creation-board ${
        isBeforeCreateLocation
          ? `animation-slide-${createNewDealMenuVisibility ? "right" : "left"}`
          : ""
      }`}
    >
      <div className="deals-creation-content">
        {!dealId && (
          <div className="deals-creation-content-title">
            {isBeforeCreateLocation ? (
              <Fragment>
                Select deal type
                <CloseLargeIcon
                  fill={colors.TERTIARY_COLOR_0}
                  className={"deals-close-icon"}
                  onClick={() => {
                    setCreateNewDealsMenuVisibility(false);
                    setTimeout(() => {
                      clickToLinkHandler(`/${orgId}/deals/`);
                    }, 500);
                  }}
                />
              </Fragment>
            ) : (
              "New Deal"
            )}
          </div>
        )}
        {dealId && deal?.companyName && (
          <div className="deals-title-container">
            <div className="deals-creation-content-title">
              {deal.companyName}, {deal.seriesOfPreferredStockSold}
            </div>
          </div>
        )}
        {dealId && deal && (
          <div className="deals-summary">
            <div className="deals-summary-titles">
              <div className="deals-summary-title">Round size</div>
              <div className="deals-summary-title">pre-money Valuation</div>
            </div>
            <div className="deals-summary-values">
              <div
                className="deals-summary-value"
                data-testid="deals-menu-summary-round-size"
              >
                ${abbreviateNumber(deal.totalRoundSize)}
              </div>
              <div
                className="deals-summary-value"
                data-testid="deals-menu-summary-valuation"
              >
                ${abbreviateNumber(deal.valuation)}
              </div>
            </div>
          </div>
        )}
        {isBeforeCreateLocation && (
          <div className="deals-creation-content-buttons">
            <div
              className="deals-creation-content-button"
              onClick={clickToLinkHandler.bind(
                this,
                `/${orgId}/deals/create/financing`
              )}
            >
              <div className="deals-creation-label">
                Preferred Stock Financing
              </div>
            </div>
          </div>
        )}
        {!isBeforeCreateLocation && (
          <MenuList orgId={orgId} dealId={dealId} pathname={pathname} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const { user, token } = state.auth;
  const {
    location: { pathname },
  } = props;
  const {
    match: {
      params: { orgId, id: dealId },
    },
  } = props;

  const isBeforeCreateLocation = pathname.indexOf("before-create") > -1;

  return {
    user,
    token,
    pathname,
    orgId,
    dealId,
    isBeforeCreateLocation,
  };
};

export default connect(mapStateToProps)(SelectDealTypePage);
